import { ButtonFrame } from "./button";
import { ButtonIcon } from "./button-icon";
import { ButtonText } from "./button-text";
import { withStaticProperties } from "@fhs/utils";

export const Button = withStaticProperties(ButtonFrame, {
  Text: ButtonText,
  Icon: ButtonIcon,
});

export { useButtonContext } from "./button";

export type { ButtonProps, ButtonContextType } from "./button";
export type { ButtonTextProps } from "./button-text";
export type { ButtonIconProps } from "./button-icon";
